// @ts-nocheck
import { API_URLS } from '@configs/index'
import { request } from '@utils/index'

interface FetchVideoParams {
  videoId: string
  videoData?: Pick<VideoDataGlobal, 'id' | 'signature'>
}

export const fetchVideo = async ({ videoId, videoData }: FetchVideoParams, token?: string) => {
  if (videoData) videoId = videoData.id + '?s=' + videoData.signature

  let url
  if (token) {
    url = API_URLS.VIDEO_PRIVATE.createURL(videoId)
  } else {
    url = API_URLS.VIDEO_PUBLIC.createURL(videoId)
  }
  // error processing is inside request fn -> show a toast with error message
  const response = await request({ url })
  return response ? response : null
}
